import type { ModuleDefinition } from "../types";
import "./messages.nav";
import { BILLING_REPORTS, EXPENSES_READ } from "./permissions";

const screens = () => import("./screens");

/** Expenses (vendors, entries, bills, other income) and the billing reports. Entitled by the billing license. */
export const expensesModule: ModuleDefinition = {
  id: "expenses",
  licenseModule: "billing",
  labelKey: "module.expenses",
  nav: [
    { id: "expenses-entries", labelKey: "exp.nav.entries", to: "/expenses/entries", icon: "tag", permission: EXPENSES_READ },
    { id: "expenses-vendors", labelKey: "exp.nav.vendors", to: "/expenses/vendors", icon: "building", permission: EXPENSES_READ },
    { id: "expenses-reports", labelKey: "exp.nav.reports", to: "/expenses/reports", icon: "log", permission: BILLING_REPORTS },
  ],
  routes: [
    { path: "expenses", permission: EXPENSES_READ, load: async () => ({ default: (await screens()).ExpensesIndexRedirect }) },
    { path: "expenses/entries", permission: EXPENSES_READ, load: async () => ({ default: (await screens()).ExpensesPage }) },
    { path: "expenses/vendors", permission: EXPENSES_READ, load: async () => ({ default: (await screens()).VendorsPage }) },
    { path: "expenses/vendors/:vendorId", permission: EXPENSES_READ, load: async () => ({ default: (await screens()).VendorPage }) },
    { path: "expenses/categories", permission: EXPENSES_READ, load: async () => ({ default: (await screens()).CategoriesPage }) },
    { path: "expenses/income", permission: EXPENSES_READ, load: async () => ({ default: (await screens()).IncomePage }) },
    { path: "expenses/reports", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).ReportsIndexPage }) },
    { path: "expenses/reports/department-pnl", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).DepartmentPnlPage }) },
    { path: "expenses/reports/spending", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).SpendingPage }) },
    { path: "expenses/reports/ar-aging", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).AgingPage }) },
    { path: "expenses/reports/revenue", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).RevenuePage }) },
    { path: "expenses/reports/journal", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).JournalPage }) },
    { path: "expenses/reports/reconciliation", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).ReconciliationPage }) },
    { path: "expenses/reports/export", permission: BILLING_REPORTS, load: async () => ({ default: (await screens()).ExportPage }) },
  ],
};
